/**
 * ヘルプページのURLを組み立てるクラス
 */
export default class HelpUrlUtil {

    /**
     * ヘルプページTOPへのURL
     * @param {string} helpPageKind ヘルプページの種類
     */
    helpTopUrl = (helpPageKind) => `/web/common/help/top/${helpPageKind}`;

    /**
     * ヘルプ詳細ページへのURLを返す.
     */
    helpDetailUrl = (helpId) => `/web/common/help/answer/${helpId}`;

}